import Booking from './Booking'
import BookingField from './BookingField.vue'
import BookingForm from './BookingForm.vue'
import BookingQrcode from './BookingQrcode.vue'
import Thank from './Thank.vue'
import UserHistory from './UserHistory.vue'
import ConditionFlow from './ConditionFlow.vue'
import BookingAddress from './BookingAddress.vue'
import CheckBookingLatest from './CheckBookingLatest.vue'
import CheckBookingNext from './CheckBookingNext.vue'
import ConfirmUser from './ConfirmUser.vue'
import PaymentUpload from './PaymentUpload.vue'
import CalendarBooking from './CalendarBooking.vue'
import BookingFormEmp from './BookingFormEmp.vue'
import BookingQrcodeCheckConfirmJob from './BookingQrcodeCheckConfirmJob.vue'
import Realtimequeue from './Realtimequeue.vue'
import BookingFormNoLine from './BookingFormNoLine.vue'
import CalendarBookingEmp from './CalendarBookingEmp.vue'
import CheckQueueStoreFront from './CheckQueueStoreFront.vue'
import CheckQueueStoreFrontPos from './CheckQueueStoreFrontPos.vue'
import CheckRealdyQueueStoreFront from './CheckRealdyQueueStoreFront.vue'
import EmpList from './EmpList.vue'
import UpdateLineUserID from './UpdateLineUserID.vue'
import CheckQueueStoreFrontToDayByLineUser from './CheckQueueStoreFrontToDayByLineUser.vue'
import BookingFormAutoEmp from './BookingFormAutoEmp.vue'
import CalendarBookingAutoEmp from './CalendarBookingAutoEmp'
import BookingFormEmpNoLine from './BookingFormEmpNoLine.vue'
import EditBooking from './EditBooking.vue'
import CheckQueueStoreFrontOhRich from './CheckQueueStoreFrontOhRich.vue'
import CheckQueueStoreFrontKioskS from './CheckQueueStoreFrontKioskS.vue'
import CalendarBookingEmp2 from './CalendarBookingEmp2.vue'
import CalendarBookingBBQPlaza from './CalendarBookingBBQPlaza.vue'
import CalendarBookingNoLine from './CalendarBookingNoLine.vue'
import CalendarBookingEmpNoLine from './CalendarBookingEmpNoLine.vue'
import CalendarBookingAutoEmpNoLine from './CalendarBookingAutoEmpNoLine.vue'
import BookingFormAutoEmpNoLine from './BookingFormAutoEmpNoLine.vue'
import CheckQueueStoreFrontEvent from './CheckQueueStoreFrontEvent.vue'
import CheckQueueStoreFrontPopMart from './CheckQueueStoreFrontPopMart.vue'
import BookingFormEmpEx10 from './BookingFormEmpEx10.vue'
import BookingFormAutoEmpEx10 from './BookingFormAutoEmpEx10.vue'
import BookingFormEx10 from './BookingFormEx10.vue'
import BookingSwitch from './BookingSwitch.vue'
import DetailBookingEx10 from './DetailBookingEx10.vue'
import BookingFormChatMe from './BookingFormChatMe.vue'
import DetailBookingChatMe from './DetailBookingChatMe.vue'
import BookingFormEmpChatMe from './BookingFormEmpChatMe.vue'
import BookingFormAutoEmpChatMe from './BookingFormAutoEmpChatMe.vue'
import BookingSwitchChatMe from './BookingSwitchChatMe.vue'
import BookingHistoryChatMe from './BookingHistoryChatMe.vue'
import BookingHistoryEx10 from './BookingHistoryEx10.vue'
import BookingHistory from './BookingHistory.vue'
import BookingFormKruBeer from './BookingFormKruBeer.vue'
import BookingSelect from './BookingSelect.vue'
import ShareFlex from './ShareFlex.vue'
import ShareFlowStep from './ShareFlowStep.vue'
import JoyrideReview from './JoyrideReview.vue'
import SaveUserIdEmployee from './SaveUserIdEmployee.vue'
import Shop from './Shop.vue'

export default {
  Booking,
  BookingForm,
  BookingFormEmp,
  BookingFormKruBeer,
  BookingField,
  BookingQrcode,
  Thank,
  UserHistory,
  ConditionFlow,
  BookingAddress,
  CheckBookingLatest,
  CheckBookingNext,
  ConfirmUser,
  PaymentUpload,
  CalendarBooking,
  BookingQrcodeCheckConfirmJob,
  Realtimequeue,
  BookingFormNoLine,
  CalendarBookingEmp,
  CalendarBookingEmp2,
  CheckQueueStoreFront,
  CheckRealdyQueueStoreFront,
  EmpList,
  UpdateLineUserID,
  CheckQueueStoreFrontToDayByLineUser,
  BookingFormAutoEmp,
  CalendarBookingAutoEmp,
  BookingFormEmpNoLine,
  EditBooking,
  CheckQueueStoreFrontOhRich,
  CheckQueueStoreFrontKioskS,
  CalendarBookingNoLine,
  CalendarBookingEmpNoLine,
  CalendarBookingAutoEmpNoLine,
  BookingFormAutoEmpNoLine,
  CheckQueueStoreFrontEvent,
  BookingFormEmpEx10,
  BookingFormAutoEmpEx10,
  BookingFormEx10,
  BookingSwitch,
  DetailBookingEx10,
  BookingFormChatMe,
  DetailBookingChatMe,
  BookingFormEmpChatMe,
  BookingFormAutoEmpChatMe,
  BookingSwitchChatMe,
  BookingHistoryChatMe,
  BookingHistoryEx10,
  BookingHistory,
  BookingSelect,
  CalendarBookingBBQPlaza,
  ShareFlex,
  ShareFlowStep,
  JoyrideReview,
  CheckQueueStoreFrontPos,
  SaveUserIdEmployee,
  CheckQueueStoreFrontPopMart,
  Shop
}



// WEBPACK FOOTER //
// ./src/components/Booking/index.js